import Typography from '@mui/material/Typography';
import ConfirmationDialog from 'components/system/ConfirmationDialog';

const AccountDeactivateConfirmation = ({ onConfirm, onCancel, onClose }) => (
  <ConfirmationDialog
    title="Deactivate Account"
    onCancel={onCancel}
    onClose={onClose}
    onConfirm={onConfirm}
    confirmText="Deactivate"
    reversed
  >
    <Typography variant="body2">
      Are you sure you want to deactivate your account?
    </Typography>
  </ConfirmationDialog>
);

export default AccountDeactivateConfirmation;
